import styled from 'styled-components';
import { placeHolderShimmer } from '../../../styles/keyFrames';
var StyledCustom = /*#__PURE__*/styled.div.withConfig({
  displayName: "Custom__StyledCustom",
  componentId: "sc-1nlrvox-0"
})(["width:", ";height:", ";animation-name:", ";animation-duration:1.25s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-timing-function:linear;background:linear-gradient(to right,#eeeeee 10%,#dddddd 18%,#eeeeee 33%);background-size:100vw 104px;", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, placeHolderShimmer, function (props) {
  return props.isCircle && "border-radius: 50%;\n  ";
});
export default StyledCustom;